<template>
  <div class="my-3">
    <div class="mb-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="necessary" v-model="cookies.necessary" disabled="1" />
        <label class="form-check-label fw-bold" for="necessary">{{$t('cookies.strictlyNecessary.label')}}</label>
      </div>
      <p>
        {{$t('cookies.strictlyNecessary.description')}}
      </p>
    </div>

    <div class="mb-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="functional" v-model="cookies.functional" />
        <label class="form-check-label fw-bold" for="functional">{{$t('cookies.functional.label')}}</label>
      </div>
      <p>
        {{$t('cookies.functional.description')}}
      </p>
    </div>

    <div class="mb-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="performance" v-model="cookies.analysis" />
        <label class="form-check-label fw-bold" for="performance">{{$t('cookies.performance.label')}}</label>
      </div>
      <p>
        {{$t('cookies.performance.description')}}
      </p>
    </div>

    <div class="mb-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="ads" v-model="cookies.ads"  />
        <label class="form-check-label fw-bold" for="ads">{{$t('cookies.ads.label')}}</label>
      </div>
      <p>	
         {{$t('cookies.ads.description')}}
      </p>
    </div>
    <div class="mb-5">
      <div class="fw-bold">{{$t('cookies.thirdparty.label')}}</div>
      <p>	
        {{$t('cookies.thirdparty.description')}}
      </p>
      <ul>
      
        <i18n-t keypath="cookies.stripe_label" tag="li" for="cookies.stripe_link">
          <a href="https://stripe.com">{{ $t('cookies.stripe_link') }}</a>
        </i18n-t>
     
        <i18n-t keypath="cookies.zendesk_label" tag="li" for="cookies.zendesk_link">
           <a href="https://zendesk.com">{{ $t('cookies.zendesk_link') }}</a>
        </i18n-t>
        
        <i18n-t keypath="cookies.google_label" tag="li" for="cookies.google_link">
          <a href="https://developers.google.com/analytics">{{ $t('cookies.google_link') }}</a>
        </i18n-t>

      </ul>
    </div>

    <div class="row">
      <button type="button" class="btn btn-secondary col-lg-3" @click="enableAllCookies()">{{$t('cookies.enableAll')}}</button>
      <button type="button" class="btn btn-secondary col-lg-3" @click="disableAllCookies()">{{$t('cookies.rejectOptional')}}</button>
      <div class="d-none d-lg-block col-lg-3">&nbsp;</div>
      <button type="button" @click="saveReturn()" class="btn btn-primary col-lg-3">{{$t('cookies.returnHome')}}</button>
    </div>
  </div>
</template>
<script setup>
import { i18Utils } from "@/visualcrossing-core/i18utils";
</script>
<script>
import translations from '@/translations/cookiepreferences.js';
import { VcLocationsStorage } from "/src/visualcrossing-core/vclocationsstorage";

export default {
  name: 'CookiePreferences',
  data() {
    return {
      cookies:VcLocationsStorage.getAllCookies()
    };
  },
  i18n: {
    messages: translations,
  },
  methods:{
    enableAllCookies( ){
      var me=this;
      me.cookies.necessary=true;
      me.cookies.functional=true;
      me.cookies.analysis=true;
      me.cookies.ads=true;
    },
    disableAllCookies( ){
      var me=this;
      me.cookies.necessary=true;
      me.cookies.functional=false;
      me.cookies.analysis=false;
      me.cookies.ads=false;
    },
     clearAllCookies( ){
        var me=this;
        VcLocationsStorage.resetAllCookies();
     },
     saveReturn() {
       var me=this;
       VcLocationsStorage.setAllCookies(cookies);
       i18Utils.redirectTo("");
       //window.location="/";
     }
  },
  computed:{
   
  },
  watch: {
       cookies:{
        handler:function(newValue,oldValue) {
          var me=this;
          VcLocationsStorage.setAllCookies(newValue);
        },
        deep: true
    },
  },
  mounted() {
    var me=this;
   
  },
  components: {
   
  }
};
</script>
